jQuery(document).ready(function ($) {
  if (jQuery('body.woocommerce-cart').length) {
    var remarkDirty = false;
    jQuery(document).on('change', '.woocommerce-cart-form .cart_item .qty, .woocommerce-cart-form .cart_item .cart-item-remark input', function () {
      updateCart = setTimeout(function () {
        jQuery('button[name=\'update_cart\']').trigger('click');
      }, 1200);
    });
    jQuery(document).on('input', '.woocommerce-cart-form .cart_item .cart-item-remark input', function () {
      remarkDirty = true;
    });

    // Enter would implicitly submit via the coupon button; update the cart instead.
    jQuery(document).on('keydown', '.woocommerce-cart-form .cart_item .cart-item-remark input', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        jQuery('button[name=\'update_cart\']').trigger('click');
      }
    });

    // An unsaved remark would be lost on direct navigation to checkout. Submitting
    // the cart form with `proceed` makes WooCommerce save the cart, then redirect
    // to checkout itself (WC_Form_Handler::update_cart_action).
    jQuery(document).on('click', '.wc-proceed-to-checkout .checkout-button', function (e) {
      if (!remarkDirty) {
        return;
      }
      e.preventDefault();
      clearTimeout(updateCart);
      jQuery('<input>', {
        type: 'hidden',
        name: 'proceed',
        value: '1'
      }).appendTo('.woocommerce-cart-form');
      jQuery('.woocommerce-cart-form').trigger('submit');
    });
  }
});